// @flow
import JQueryView, { on } from '../../common/JQueryView';
import flashMessage from '../../../utils/flashMessage';

export default class ShareGroupLink extends JQueryView {
  constructor() {
    super('.investor_document_groups');
  }

  @on({ event: 'click', selector: '.copy-share-link' })
  copyToClipboard(e: any) {
    const shareLink = e.currentTarget.dataset.link;
    if (shareLink) {
      navigator.clipboard.writeText(shareLink);
      flashMessage('共有リンクをコピーしました', 'success');
    } else {
      flashMessage(
        '共有リンクをコピーできませんでした。再度お試しください。',
        'error',
      );
    }
  }
}
